// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2a0gN","list":"styles_list__2nv4w"};